import {Injectable} from '@angular/core';
import {EdiFileBaseService} from "@app/processing/services/edi-file-base.service";
import {GlobalService} from "@app/_services/global.service";
import {ApiService} from "@app/_services/api.service";
import {Observable} from "rxjs";
import {
    BackoutRequest,
    BackoutResponse,
    EdiFileSummaryFilter,
    EdiFileSummaryResponse,
    EdiInvalidIdentifier,
    ReprocessingFile,
    ReprocessingResponse
} from "@app/_models/api";

@Injectable({
    providedIn: 'root'
})
export class EdiFile852Service extends EdiFileBaseService {
    override fileType: string = '852';
    constructor(globalService: GlobalService, apiService: ApiService) {
        super(globalService, apiService);
    }

    getFiles(filter: EdiFileSummaryFilter): Observable<EdiFileSummaryResponse[]> {
        return this.apiService.getEdi852FileSummary(filter);
    }

    getInvalidIdentifiers(customerId: string): Observable<EdiInvalidIdentifier[]> {
        return this.apiService.getEdi852InvalidIdentifiers(customerId);
    }

    submitReprocessingRequest(files: ReprocessingFile[]): Observable<ReprocessingResponse> {
        return this.apiService.reprocess852Files(files);
    }

    submitBackoutRequest(files: BackoutRequest[]): Observable<BackoutResponse> {
        return this.apiService.backout852Files(files);
    }
}
